import { Component, Input, SimpleChanges } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
 
// [formControl]="formControl" [formlyAttributes]="field"
  @Component({
    selector: 'relatesto-personobserved',
    styles: [`
      label.checked {
        border-color: #006884;
        border-width: 2.5px;
      }
      .margin_top{
        margin-top:-10px;
      }
      .horizontal_line{
        width:100%;border-bottom:2px solid #0073824D;margin-bottom: 20px;
      }
      .lebel_text{
        color:#000000;
        font-weight:600;
      }
      .mandatory_flag{
        color:red;
      }
    `],
    template: `
    <ion-label class="lebel_text">
      {{to.label}}<span *ngIf="to.required" class="mandatory_flag">*</span>
    </ion-label>
    <div class="wrapper margin_top" *ngIf="to.myoptions"> 
      <div class="sub_blk" *ngFor="let option of to.myoptions; let i = index" (click)="onChange(option.value)">
        <input type="radio" [disabled]="to.disabled" name="to.name" id="{{option.label | translate}}" class="radio_blk" 
        [ngClass]="{'checked': option.value == formControl.value }" [checked]="option.value == formControl.value" [disabled]="option.disabled">
        <label for="{{option.value}}" class="option" [ngClass]="{'checked': option.value == formControl.value }" >
         <span>{{option.label | translate}}</span>
        </label>
      </div>
      {{locationsType}}
    </div>
    `,
    standalone: false
})
   
  export class CvpcPersonObservedFormlyType extends FieldType {
    locationsType;
    isSelected:any;
    previousValue: string = '';
    constructor() {
      super();
    }

    ngOnInit(){
      this.isSelected = this.to.defaultset;
    }
    

    onChange(option: any) {
      if(this.to.disabled){
        return
      }
      this.formControl.patchValue(option);
      this.formControl.markAsTouched();
    }

  }
  